import React, { FC } from 'react'
import { useFormikContext } from 'formik'

import { Select, SelectOption, SelectProps } from './Select'

type Props = Omit<SelectProps, 'value' | 'onChange'> & {
  name: string
  onChange?: (option: SelectOption, value: string) => void
}

const resolveSelectValue = (formValue: SelectOption | string | undefined, options: SelectOption[]) => {
  if (!formValue) {
    return undefined
  }

  if (typeof formValue === 'object') {
    return options.find(option => option.value === formValue.value) ?? formValue
  }

  return options.find(option => option.value === formValue)
}

export const FormSelect: FC<Props> = ({ name, onChange, options = [], ...restProps }) => {
  const formik = useFormikContext<Record<string, SelectOption | string>>()

  const formValue = formik.values[name]
  const value = resolveSelectValue(formValue, options)

  const handleChange = (option: SelectOption, newValue: string) => {
    formik.setFieldValue(name, option)
    onChange?.(option, newValue)
  }

  return <Select value={value} options={options} onChange={handleChange} {...restProps} />
}
